const focusableSelector = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
].join(",");

export const isSafariUserAgent = (userAgent: string) =>
  /safari/i.test(userAgent) && !/(chrome|chromium|crios|android|edg|opr)/i.test(userAgent);

export const visibleFocusableElements = (root: ParentNode) =>
  Array.from(root.querySelectorAll<HTMLElement>(focusableSelector)).filter(element => {
    if (element.hidden || element.getAttribute("aria-hidden") === "true" || element.closest("[inert]")) return false;
    const style = window.getComputedStyle(element);
    return style.display !== "none" && style.visibility !== "hidden";
  });

export const installSafariTabNavigation = (
  documentRoot: Document = document,
  userAgent: string = navigator.userAgent,
) => {
  if (!isSafariUserAgent(userAgent)) return () => undefined;
  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key !== "Tab" || event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) return;
    const modal = documentRoot.querySelector<HTMLElement>('[aria-modal="true"]');
    const items = visibleFocusableElements(modal || documentRoot);
    if (!items.length) return;
    const current = items.indexOf(documentRoot.activeElement as HTMLElement);
    const next = event.shiftKey
      ? (current <= 0 ? items.length - 1 : current - 1)
      : (current < 0 || current === items.length - 1 ? 0 : current + 1);
    event.preventDefault();
    items[next].focus();
  };
  documentRoot.addEventListener("keydown", onKeyDown);
  return () => documentRoot.removeEventListener("keydown", onKeyDown);
};
